import ErpCrud from "@/components/ErpCrud";

export default function AdminQuotations() {
  return (
    <ErpCrud
      testid="admin-quotations"
      title="Quotations"
      subtitle="Customer quotes / estimates — app ke saath synced"
      endpoint="/admin/quotations"
      fields={[
        { key: "customer_name", label: "Customer", type: "text" },
        { key: "customer_phone", label: "Phone", type: "text" },
        { key: "items_text", label: "Items (e.g. 2x Fan @1200)", type: "textarea" },
        { key: "subtotal", label: "Subtotal ₹", type: "number" },
        { key: "gst", label: "GST ₹", type: "number" },
        { key: "valid_until", label: "Valid Until", type: "date" },
        { key: "status", label: "Status", type: "select", options: [
          { value: "draft", label: "Draft" }, { value: "sent", label: "Sent" },
          { value: "accepted", label: "Accepted" }, { value: "rejected", label: "Rejected" },
        ] },
        { key: "notes", label: "Notes", type: "textarea" },
      ]}
      columns={[
        { key: "quote_no", label: "Quote #" },
        { key: "customer_name", label: "Customer" },
        { key: "total", label: "Total", render: (r) => `₹${r.total ?? 0}` },
        { key: "valid_until", label: "Valid Until" },
        { key: "status", label: "Status" },
      ]}
    />
  );
}
